import React from 'react';
import styled from 'styled-components';
import * as PropTypes from 'prop-types';
import colors from '../../../lib/Colors';

const CustomDelimiterLine = styled.hr`
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid ${({color}) => color ? color : colors.mediumGray};
    margin: 1em 0;
    padding: 0;
`;

const LineWithText = styled.div`
    color: ${colors.mediumGray};
    display:flex;
    flex-wrap:nowrap;
    align-items:center;
    margin: ${props => props.margin}px 0;
&:before, &:after {
    background-color: ${colors.mediumGray};
    content: "";
    display: inline-block;
    float:left;
    height:1px;
  }
&:before {
    order:1;
    flex-grow:1;
    margin-right:8px;
  }
&:after {
    order: 3;
    flex-grow: 1;
    margin-left: 8px;
  }
* {
    order: 2;
  }
`;

const DelimiterLine = ({margin, text, type, color,}) => {
  switch (type) {
    case 'baseLine':
      return (<CustomDelimiterLine color={color}/>);
    case 'lineWithText':
      return (<LineWithText margin={margin}>
        <span>{text}</span></LineWithText>);
    default:
      return null;
  }
};

DelimiterLine.propTypes = {
  color: PropTypes.string,
  margin: PropTypes.number,
  text: PropTypes.string,
  type: PropTypes.oneOf(['baseLine'])
};

DelimiterLine.defaultProps = {
  margin: 0,
  text: 'or',
  type: 'baseLine',
};

export default DelimiterLine;
